module.exports = __webpack_public_path__ + "static/media/basic-card.190e5ad6.png";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/basic-card.png
// module id = 2908
// module chunks = 0